export const generateSlug = (name: string): string =>
    name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

export const makeUniqueSlug = (base: string, taken: string[]): string => {
    if (!base || !taken.includes(base)) return base;
    let i = 2;
    while (taken.includes(`${base}-${i}`)) i++;
    return `${base}-${i}`;
};
